<template>
  <div class="plan-form-wrap">
    <div class="plan-form-summary">
      <div class="plan-form-hint">
        <i class="el-icon-info"></i>
        <span>
          除<strong>基础信息</strong>外，请在下列页签中完成<strong>指挥体系</strong>、<strong>应急响应</strong>、<strong>资源保障</strong>、<strong>物资与专家</strong>的配置；与基础信息分开展示，点击下方提交与列表页相同接口整单保存。
        </span>
      </div>
      <div class="plan-form-status" v-if="!isEdit">
        <span class="plan-form-pill">待审核</span>
      </div>
    </div>
    <el-tabs v-model="activeName" class="plan-main-tabs" type="card" @tab-click="handleClick">
      <el-tab-pane label="基础信息" name="t1">
        <BaseInfo ref="baseInfo" :info-more="infoMore" />
      </el-tab-pane>
      <el-tab-pane label="指挥体系" name="t2">
        <OrganizationX6
          ref="organizationX6"
          :active-name="activeName"
          :info="commandSystemRoot"
        />
      </el-tab-pane>
      <el-tab-pane label="应急响应" name="t3">
        <responsesContent ref="responsesContent" :info-more="infoMore" />
      </el-tab-pane>
      <el-tab-pane label="资源保障" name="t4">
        <resourceGuarantee ref="resourceGuarantee" :info-more="infoMore" />
      </el-tab-pane>
      <el-tab-pane label="物资与专家" name="t5">
        <ResourceManagement ref="resourceManagement" :info-more="infoMore" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BaseInfo from './secondary-form/baseInfo.vue'
import OrganizationX6 from './secondary-form/organizationX6.vue'
import ResourceManagement from './secondary-form/resource-management.vue'
import resourceGuarantee from './secondary-form/resource-guarantee.vue'
import responsesContent from './secondary-form/responses-content.vue'

export default {
  name: 'WantMore',
  components: {
    BaseInfo,
    OrganizationX6,
    ResourceManagement,
    resourceGuarantee,
    responsesContent
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    infoMore: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      activeName: 't1'
    }
  },
  computed: {
    commandSystemRoot () {
      const list = this.infoMore && this.infoMore.commandSystems
      if (Array.isArray(list) && list.length > 0) {
        return list[0]
      }
      return {}
    }
  },
  methods: {
    handleClick (tab, event) {
      // 供指挥体系页签懒加载画布等使用
      this.$emit('tab-click', tab, event)
    },
    echoData () {
      const baseInfo = this.$refs.baseInfo.echoData()
      const commandSystems = this.$refs.organizationX6.echoData()
      const resourceSupports = this.$refs.resourceGuarantee.echoData()
      const responses = this.$refs.responsesContent.echoData()
      const { materials, experts } = this.$refs.resourceManagement.echoData()
      return {
        ...baseInfo,
        commandSystems,
        resourceSupports,
        materials,
        experts,
        responses
      }
    }
  }
}
</script>

<style scoped lang="scss">
.plan-form-wrap {
  min-height: 100%;
  padding: 0 0 16px;
  background: #f4f7fb;
}

.plan-form-summary {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px 14px;
  background: #eef4ff;
  border: 1px solid #d9e7ff;
  border-radius: 8px;
}

.plan-form-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  font-size: 12px;
  color: #50627a;
  line-height: 1.6;
}

.plan-form-hint i {
  margin-top: 2px;
  color: #3b82f6;
  font-size: 14px;
}

.plan-form-hint strong {
  color: #24364f;
}

.plan-form-status {
  flex: 0 0 auto;
  padding-top: 1px;
}

.plan-form-pill {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 14px;
  border-radius: 999px;
  background: #fef3c7;
  color: #92400e;
  white-space: nowrap;
}

.plan-main-tabs {
  background: #fff;
  border-radius: 8px;
  padding: 12px 12px 14px;
  border: 1px solid #e6edf6;
  box-shadow: 0 4px 16px rgba(31, 45, 61, 0.04);
}

::v-deep .plan-main-tabs > .el-tabs__header {
  position: sticky;
  top: 0;
  z-index: 3;
  margin-bottom: 14px;
  padding: 0 0 10px;
  border-bottom: none;
  background: #fff;
}

::v-deep .plan-main-tabs .el-tabs__item {
  min-width: 112px;
  text-align: center;
  border-radius: 999px;
  margin-right: 8px;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  border: none;
  background: #f1f5f9;
  color: #526276;
  font-weight: 500;
  transition: all 0.18s ease;
}

::v-deep .plan-main-tabs .el-tabs__item:hover {
  color: #2f80ed;
  background: #eaf3ff;
}

::v-deep .plan-main-tabs .el-tabs__item.is-active {
  background: linear-gradient(135deg, #2f80ed 0%, #46a6ff 100%);
  color: #fff;
  box-shadow: 0 6px 14px rgba(47, 128, 237, 0.22);
}

::v-deep .plan-main-tabs .el-tabs__nav-wrap::after {
  display: none;
}

::v-deep .plan-main-tabs .el-tabs__active-bar {
  display: none;
}

::v-deep .plan-main-tabs .el-tabs__content {
  min-height: 520px;
  padding: 2px;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-color: #d9e1ec;
  border-radius: 4px;
}

::v-deep .el-input__inner:focus,
::v-deep .el-textarea__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.08);
}

::v-deep .el-form-item__label,
::v-deep .field-label {
  color: #334155;
  font-weight: 500;
}

::v-deep .proto-table {
  border-radius: 6px;
}

::v-deep .proto-table th {
  height: 42px;
}

::v-deep .proto-table td {
  padding: 8px 0;
}

@media (max-width: 1366px) {
  .plan-main-tabs {
    padding: 10px;
  }

  ::v-deep .plan-main-tabs .el-tabs__item {
    min-width: 96px;
    padding: 0 16px;
  }
}
</style>
